"use client";

import { ListBulletIcon } from "@heroicons/react/24/solid";
import NoSsr from "@mui/material/NoSsr";

import { useSymbol } from "@/features/analysis/hooks/use-symbol";
import { useBottomPanel } from "@/hooks/use-bottom-panel";
import { useLang } from "@/hooks/use-lang";

import { ChartNavigationClosure } from "./ChartNavigationClosure";

export const ChartNavigationPanel = () => {
  const { t } = useLang();
  const { symbol } = useSymbol();
  const { Panel, closePanel, openPanel } = useBottomPanel();

  return (
    <NoSsr>
      <button
        type="button"
        onClick={openPanel}
        className="fixed bottom-5 right-5 z-50 flex h-12 w-12 cursor-pointer items-center rounded-full bg-zinc-800 transition-all hover:scale-110 hover:bg-zinc-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 lg:hidden"
        aria-label="open chart navigation panel"
      >
        <ListBulletIcon className="m-auto h-7 w-7 shrink-0 text-white" />
      </button>
      <Panel title={t.analysis.navigation.listOfPages}>
        <ChartNavigationClosure symbol={symbol} onLinkClick={closePanel} />
      </Panel>
    </NoSsr>
  );
};
